export const askForNewBellNotifications = function (dispatch) {
    dispatch({
        type: 'ASK_FOR_NEW_NOTIFICATIONS',
    });
};
